<template>
    <div id="removeclass">
       <app-modal
        :modal-id="modalId"
        modal-alignment="top"
        modal-size="fullscreen"
        @close-modal="closeModal"
      >
            <template slot="header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
                <div v-if="this.active != 1">
                    <button
                        type="button"
                        class="btn btn-sm btn-primary el-button--default"
                        v-if="this.active < 5"
                        @click="previous"
                        style="float: right"
                    >
                        <span>Previous</span>
                    </button>
                </div>
                <button
                    v-else
                    type="button"
                    class="close outline-none"
                    data-dismiss="modal"
                    @click="closeModal"
                >
                    <span>
                    <app-icon :name="'x'"></app-icon>
                    </span>
                </button>
            </template>
            <template slot="body">
                <el-form v-if="active === 1">
                    <app-table :options="options" :id="tableId" @action="getListAction" />
                </el-form>
                <el-form v-if="active === 2">
                    <membership-historyreport :id="id" @invoiceId="invoiceid" :active="{ active }"></membership-historyreport>
                </el-form>
                <el-form v-if="active === 3">
                    <invoice-view :id="invoice_id"></invoice-view>
                </el-form>
                <el-form v-if="active === 4">
                    <my-profile :id="user_id" :remove="classRemove"></my-profile>
                </el-form>
            </template>
        </app-modal>
    </div>
</template>
    
    <script>
    import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
    import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
    import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
    import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
    import * as actions from "../../../../Config/ApiUrl";
    
    export default {
      name: "NewSupplierList",
      mixins: [FormMixin, ModalMixin, TableHelpers],
      data() {
        return {
            classRemove: true,
            active: 1,
            id: 0,
            invoice_id: 0,
            user_id:0,
            modalId: "new-supplier-list",
            modalTitle: this.$t("new_suppliers"),
            rowData: {},
            tableId: "advance-table",
            options: {
                name: "AdvanceTable",
                url: actions.MEMBERSHIP_BUYERS,
                showHeader: true,
                columns: [
                // {
                //     title: this.$t('date'),
                //     type: 'media-object',
                //     key: 'media-object',
                //     mediaTitleKey: 'name',
                //     mediaSubtitleKey: 'email',
                //     default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                //     modifier: (value, row) => {
                //         return value; // imag url
                //     },
                //     isVisible: true
                // },
                {
                    title: this.$t("status"),
                    type: "custom-html",
                    key: "company",
                    isVisible: true,
                    modifier: (value) => {
                    let ClassName = "danger";
                    let newS = "";
                    if (value && value.status === "active") {
                        newS = "Active";
                        ClassName = `success`;
                    } else if (value && value.status === "inactive") {
                        ClassName = `warning`;
                        newS = "Inactive";
                    }

                    return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                        newS
                    )}</span>`;
                    },
                },
                {
                    title: this.$t("start_date"),
                    type: "custom-html",
                    key: "company",
                    modifier: (value) => {
                    if (value != "") {
                        return `<span>${this.$t(
                            value && value.start_date ? value.start_date : "---"
                        )}</span>`;
                    }
                    },
                },
                {
                    title: this.$t("end_date"),
                    type: "custom-html",
                    key: "company",
                    modifier: (value) => {
                    if (value != "") {
                        return `<span>${this.$t(
                            value &&  value.end_date ? value.end_date : "---"
                        )}</span>`;
                    }
                    },
                },
                {
                    title: this.$t("business_category"),
                    type: "custom-html",
                    key: "company",
                    modifier: (value) => {
                    let a = (value && value.category.title) ? value.category.title : "---";
                    return `<span>${this.$t(a)}</span>`;
                    },
                },
                {
                    title: this.$t("company_name"),
                    type: "custom-html",
                    key: "company",
                    modifier: (value, row) => {
                    return `<a href="#" id="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value.company_name??'--')}</a>`;
                    },
                },
                {
                    title: this.$t("amount_due"),
                    type: "custom-html",
                    key: "company",
                    modifier: (value, row) => {
                    return `<span>${
                        value && value.invoice ? value.invoice.amount_due : "0"
                    }</span>`;
                    },
                },
                ],
                actions: [
                {
                    title: this.$t("view_history_report"),
                    icon: "eye",
                    type: "none",
                },
                {
                    title: this.$t("view_profile"),
                    icon: "eye",
                    type: "none",
                },
                ],
                filters: [
                {
                    title: this.$t("date"),
                    type: "range-picker",
                    key: "date",
                    option: ["today", "thisMonth", "last7Days", "nextYear"],
                },
                // {
                //     "title": this.$t('age'),
                //     "type": "range-filter",
                //     "key": "age-range",
                //     "maxTitle": this.$t('max_age'),
                //     "minTitle": this.$t('min_age'),
                //     "sign": ""
                // },
                {
                    title: this.$t("status"),
                    type: "checkbox",
                    key: "status",
                    option: [
                    { id: "active", value: "Active" },
                    { id: "inactive", value: "Inactive" },
                    // {id: 'invited', value: 'Invited'},
                    ],
                },
                // {
                //   title: this.$t("role"),
                //   type: "radio",
                //   key: "roles",
                //   option: [
                //     { id: "buyer", value: "Buyer" },
                //     { id: "supplier", value: "Supplier" },
                //   ],
                //   header: {
                //     title: this.$t("want_to_filter_your_list"),
                //     description: this.$t(
                //       "you_can_filter_your_data_table_which_are_created_based_on_gender"
                //     ),
                //   },
                // },
                {
                    title: this.$t("search_and_select_by_company_name"),
                    type: "drop-down-filter",
                    key: "search select",
                    option: [],
                },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "dropdown",
            },
        };
      },
      created() {
        this.options.columns = [...this.options.columns, this.actionObj];
        this.searchAndSelectFilterOptions();
      },
      methods: {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title == this.$t("view_history_report")) {
                // window.location =
                //   "/admin/membership/company/report/" + rowData.company.id;
                this.view_history(rowData.company.id)
            } else if (actionObj.title == this.$t("view_profile")) {
                this.view(rowData.id)
            }
        },
        view(id) {
            this.modalTitle = this.$t('new_supplier_profile');
            this.user_id = id;
            this.active = 4;
        },
        myFunction(id){
            let doc = document.getElementById(id);
            if(doc){
                doc.addEventListener('click', () => {
                    this.view(id);
                }); 
            }
        },
        view_history(id){
            this.modalTitle = this.$t('new_supplier_invoice_history');
            this.id = id;
            this.active = 2;
        },
        invoiceid(id) {
            this.modalTitle = this.$t('new_supplier_invoice');
            this.invoice_id = id;
            this.active = 3;
        },
        previous() {
            if (this.active == 4) {
                this.modalTitle = this.$t("new_suppliers");
                this.active = 1;
            }
            else {
                if (this.active-- < 4) this.active = this.active--;
                if (this.active == 2) {
                    this.modalTitle = this.$t('new_supplier_invoice_history');
                }
                else if(this.active == 3) {
                    this.modalTitle = this.$t('new_supplier_invoice');
                }
                else if(this.active == 4) {
                    this.modalTitle = this.$t('new_supplier_profile');
                }
                else {
                    this.modalTitle = this.$t("new_suppliers");
                }
            }
        },
        searchAndSelectFilterOptions() {
            let role = 'supplier';
            let url = actions.MEMBER_SEARCH_SELECT_BUYERS_COMPANY_NAME+'?role='+role+'&month=current';
            this.axiosGet(url).then((response) => {
                let name = this.options.filters.find(
                (element) => element.title === this.$t("search_and_select_by_company_name")
                );

                name.option = response.data.map((name) => {
                return {
                    id: name.value,
                    value: name.value,
                };
                });
            });
        },
        setMemberRole()
        {
            let role = 'supplier';
            this.options.url = actions.MEMBERSHIP_BUYERS+'?role='+role+'&month=current';
        },
      },
      mounted() {
        this.setMemberRole();
      }, 
       computed: {
        userRole() {
          return this.$store.state.user.loggedInUser;
        },
        themeMode() {
          return this.$store.state.theme;
        },
      }
    };
    </script>
    